module.exports = __webpack_public_path__ + "static/media/1-en.aac178bc.jpg";